/*
 * @Author: shuwen.chen
 * @Email: shuwen.chen@eeoa.com
 * @Date: 2021-09-10 16:47:33
 * @Last Modified by: shuwen.chen
 * @Last Modified time: 2021-09-27 10:24:11
 * @Description: 二级导航菜单
 * @Route: Route
 */
<template>
  <ul class="item-list-wrap">
    <li class="item-list-wrap-li">
      <div class="item-list-wrap-lists">
        <!-- <div class="nav-name-wrap">
          <p class="nav-name">{{ navNameObj.name }}</p>
        </div> -->
        <div v-for="(item, indexs) in list"
             :key="indexs"
             class="wrap-li">
          <div :style="bgStyle(item.bgIcon)"
               class="item-list-wrap-item"
               @click="jumpHandle( item.pathName,item.id)">
            <span v-if="item.name"
                  class="nav-chidren-name hover-mes">
              {{ item.name }}
            </span>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    navNameObj: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    imgFn(name) {
      return require(`../assets/kz/${name}.png`);
    },
    jumpHandle(name, id) {
      if (this.$route.name === name && id === this.$route.query.id) {
        return;
      }
      this.$router.push({
        name,
        query: {
          id,
        },
      });
    },
    bgStyle(img) {
      console.log(img, this.imgFn(img));
      return {
        backgroundImage: `url(${this.imgFn(img)})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100%',
      };
    },
  },
};
</script>

<style lang="scss" >
.nav-item {
  .item-list-wrap {
    position: absolute;
    top: 81px;
    right: 0;
    left: 0;
    z-index: 99;
    box-sizing: content-box;
    display: none;
    min-width: 1440px;
    min-height: 180px;
    background: #fff;
    border-radius: 0 0 10px 10px;
    box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.16);

    .nav-name-wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-right: 86px;
    }

    .nav-name {
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 24px;
      font-weight: 500;
      color: #000;
    }

    .nav-name-line {
      width: 122px;
      height: 1px;
      margin: 9px 0 12px;
      background: #000;
      opacity: 0.8;
    }

    .nav-name-en {
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 16px;
      font-weight: 500;
      color: #000;
    }

    &-li {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    .nav-chidren-name {
      margin-top: 10px;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 24px;
      font-weight: 500;
      color: #fff;
    }

    &-lists {
      display: flex;
      width: 1200px;
      padding: 0 10px;

      display: grid;
      // -ms-grid-columns: (1fr) [ 5 ];
      grid-template-columns: repeat(5, 1fr);
      grid-row-gap: 22px;
      grid-column-gap: 16px;
      // width: 100%;
      padding: 22px 0;
    }

    &-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 192px;
      height: 128px;
      margin-right: 15px;
      overflow: hidden;
      border-radius: 8px;
    }
  }

  &:hover {
    .item-list-wrap {
      display: block;
    }
  }
  .item-list-wrap-item {
    width: 216px;
    height: 114px;
    border-radius: 6px;
  }

  .wrap-li:hover .item-list-wrap-item {
    background-size: 110% !important;
    transition: all 0.3s;
  }
}
</style>
